module.exports = __webpack_public_path__ + "assets/eafcc6dca2d7b78f3aabc656acf2d10e.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/WolfRunR.mp3
 ** module id = 387
 ** module chunks = 0
 **/